import { useQuery } from '@tanstack/react-query'
import { apis } from '@/modules/apiClients'

export const activityReportQueryKey = (challengeId: string) => ['activity-report', challengeId] as const

export const useActivityReport = (challengeId: string | undefined) =>
  useQuery({
    queryKey: activityReportQueryKey(challengeId ?? ''),
    enabled: challengeId !== undefined && challengeId !== '',
    queryFn: async () => (await apis.challengeService.getActivityReport(challengeId ?? '')).data,
  })
